const decodeHtml = (str) => {
    var map =
    {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#38;': "&",
        '&#39;': "'",
        '&#34;': '"',
        '&num;': '#'
    };
    return str.toString().replace(/&amp;|&lt;|&gt;|&quot;|&#38;|&#39;|&#34;|&num;/g, function(m) {return map[m];});
}

export default decodeHtml